export const SEED_PRODUCTS = [
  {
    id: "p1",
    name: "Teh Bunga Telang",
    category: "Teh Herbal",
    description: "Teh biru dari kelopak bunga telang alami.",
    benefit: "Antioksidan tinggi, membantu relaksasi & kesehatan mata.",
    price: 28000,
    stock: 42,
    image: "https://images.pexels.com/photos/34439025/pexels-photo-34439025.jpeg",
    active: true,
  },
  {
    id: "p2",
    name: "Teh Rosela Merah",
    category: "Teh Herbal",
    description: "Kelopak rosela pilihan, diseduh segar setiap saat.",
    benefit: "Membantu menjaga tekanan darah & imun tubuh.",
    price: 32000,
    stock: 20,
    image: "https://images.pexels.com/photos/34481087/pexels-photo-34481087.jpeg",
    active: true,
  },
  {
    id: "p3",
    name: "Wedang Jahe Madu",
    category: "Minuman Hangat",
    description: "Racikan jahe merah dengan madu murni.",
    benefit: "Menghangatkan tubuh, meredakan masuk angin.",
    price: 25000,
    stock: 8,
    image: "https://images.pexels.com/photos/34928357/pexels-photo-34928357.jpeg",
    active: true,
  },
  {
    id: "p4",
    name: "Kunyit Asam Segar",
    category: "Jamu Tradisional",
    description: "Minuman tradisional kunyit & asam jawa.",
    benefit: "Melancarkan pencernaan & meredakan nyeri haid.",
    price: 22000,
    stock: 35,
    image: "https://images.unsplash.com/photo-1608060563275-a60fb5027f8d",
    active: true,
  },
  {
    id: "p5",
    name: "Wedang Sereh Lemon",
    category: "Minuman Hangat",
    description: "Sereh wangi dipadukan lemon segar.",
    benefit: "Menyegarkan badan & membantu detoksifikasi.",
    price: 24000,
    stock: 0,
    image: "https://images.pexels.com/photos/10802278/pexels-photo-10802278.jpeg",
    active: true,
  },
];

export const SEED_COURIERS = [
  { id: "c1", name: "JNE Reguler", cost: 12000, eta: "2-3 hari", active: true },
  { id: "c2", name: "J&T Express", cost: 13000, eta: "2-3 hari", active: true },
  { id: "c3", name: "SiCepat Halu", cost: 10000, eta: "3-4 hari", active: true },
  { id: "c4", name: "Gojek Instan", cost: 22000, eta: "1-3 jam", active: true },
];

export const PAYMENT_METHODS = [
  { id: "bca", label: "Transfer Bank BCA", type: "bank" },
  { id: "mandiri", label: "Transfer Bank Mandiri", type: "bank" },
  { id: "bri", label: "Transfer Bank BRI", type: "bank" },
  { id: "qris", label: "QRIS (semua e-wallet)", type: "qris" },
  { id: "cod", label: "Bayar di Tempat (COD)", type: "cod" },
];

export const stockBadge = (stock) => {
  if (stock <= 0) return { label: "Habis", tone: "danger" };
  if (stock < 10) return { label: "Stok Menipis", tone: "warning" };
  return { label: "Stok Aman", tone: "success" };
};

export const orderStatusMeta = {
  menunggu: { label: "Menunggu Pembayaran", tone: "warning" },
  dibayar: { label: "Dibayar", tone: "info" },
  diproses: { label: "Diproses", tone: "info" },
  dikirim: { label: "Dikirim", tone: "purple" },
  selesai: { label: "Selesai", tone: "success" },
};
